import {createSlice} from "@reduxjs/toolkit";

export interface ISpeciality {
    id: number | null
    name: string
}

interface IDocSpeciality {
    id: number | null
    price: string
    discount: number
    for_child: number | null
    child_price: string
    child_discount: number
    doctor: number | null
    speciality: ISpeciality
    child_age_from:string
    child_age_to:string
    is_active:boolean,
    address:number|null
}

interface IInitState {
    specialities: IDocSpeciality
}

const initialState: IInitState = {
    specialities: {
        id: null,
        price: '0',
        discount: 0,
        for_child: null,
        child_price: '0',
        child_discount: 0,
        doctor: null,
        speciality: {
            id: null,
            name: ''
        },
        child_age_from:'0 мес.',
        child_age_to:'18 лет',
        is_active:true,
        address:null
    },

}

const specialityReducer = createSlice({
    name: 'speciality',
    reducers: {
        setSpecialities: (state, {payload}) => {
            // if (payload.spec_id) {
            //     state.specialities.id = payload.id
            // }
            if (payload.id) {
                state.specialities.id = payload.id
            }
            if (payload.price) {
                state.specialities.price = payload.price
            }
            if (payload.discount) {
                state.specialities.discount = payload.discount
            }
            if (payload.for_child) {
                state.specialities.for_child = 1
            } else if (payload.for_child === null) {
                state.specialities.for_child = null
            } else {
                state.specialities.for_child = 0
            }
            if (payload.child_price) {
                state.specialities.child_price = payload.child_price
            }
            if (payload.child_discount) {
                state.specialities.child_discount = payload.child_discount
            }
            if (payload.doctor) {
                state.specialities.doctor = payload.doctor
            }
            if (payload.speciality) {
                state.specialities.speciality.id = payload.speciality.id
                state.specialities.speciality.name = payload.speciality.name
            }
            if (payload.child_age_from) {
                state.specialities.child_age_from = payload.child_age_from
            }
            if (payload.child_age_to) {
                state.specialities.child_age_to = payload.child_age_to
            }
            // if (payload.is_active) {
                state.specialities.is_active = payload.is_active
            //}
            if (payload.address) {
                state.specialities.address = payload.address
            }

        },
        clearSpecialities: (state) => {
            state.specialities.id = null
            state.specialities.price = '0'
            state.specialities.discount = 0
            state.specialities.for_child = null
            state.specialities.child_price = '0'
            state.specialities.child_discount = 0
            state.specialities.child_age_from = '0 мес.'
            state.specialities.child_age_to = '18 лет'
            state.specialities.speciality.id = null
            state.specialities.speciality.name = ''
            state.specialities.address = null
        },

    },
    initialState,

})

export const {setSpecialities, clearSpecialities} = specialityReducer.actions
export default specialityReducer.reducer
